import { createStore } from 'vuex'
import nticketCategory from "@/store/nticket/nticketCategory";
import competitionCategory from "@/store/competition/competitionCategory";

// Vue.use(Vuex)

const state = {
  PagePathStatus: true,
  PageParentBackPath: () => {
  },
  PageChildBackPath: () => {
  },
  partner: {},
  backStatus: {
    registerBack: true
  }
};

export default createStore({
  state,
  modules: {
    nticketCategory,
    competitionCategory
  },
  plugins: [

    // createPersistedState(),

  ],
})
